/**
 * Reverse geocoding: Koordinaten -> Adresse via Nominatim (OSM)
 */

export interface Coordinates {
  lat: number
  lon: number
}

export function parseCoordinates(value: string | null | undefined): Coordinates | null {
  if (!value) return null
  try {
    const coords = value.split(',').map(s => parseFloat(s.trim()))
    if (coords.length === 2 && !isNaN(coords[0]) && !isNaN(coords[1])) {
      return { lat: coords[0], lon: coords[1] }
    }
  } catch {}
  return null
}

export async function reverseGeocode(lat: number, lon: number): Promise<string> {
  try {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}&zoom=18&addressdetails=1`,
      { headers: { 'Accept-Language': 'de' } }
    )
    const data = await response.json()

    if (data.address) {
      const addr = data.address
      const parts: string[] = []
      if (addr.road) parts.push(addr.road)
      if (addr.house_number) parts.push(addr.house_number)
      if (addr.postcode) parts.push(addr.postcode)
      if (addr.city || addr.town || addr.village || addr.municipality) {
        parts.push(addr.city || addr.town || addr.village || addr.municipality)
      } else if (addr.county) {
        parts.push(addr.county)
      }
      if (parts.length > 0) {
        return parts.join(' ')
      }
    }
    return data.display_name || `${lat.toFixed(6)}, ${lon.toFixed(6)}`
  } catch {
    return `${lat.toFixed(6)}, ${lon.toFixed(6)}`
  }
}

export function formatEinsatzort(value: string | null | undefined): string {
  if (!value) return '—'
  return value
}

export async function formatEinsatzortAsync(value: string | null | undefined): Promise<string> {
  if (!value) return '—'
  const coords = parseCoordinates(value)
  if (coords) {
    return await reverseGeocode(coords.lat, coords.lon)
  }
  return value
}
